var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ClientRecords',{attrs:{"userList":_vm.userList,"ClientList":_vm.ClientList},on:{"SearchName":_vm.search,"RESET":_vm.ClientMaster}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }